import * as Yup from "yup";

import { FIELD_REQUIRED_MESSAGE } from "../utils/validations";

//largeLogo:    "https://dash.fitmewise.com/uploads/branch_large_logo/bax7izv1pn.png",
export const branchInitialValues = {
  gymId: "",
  branch: "",
  logo: "",
  largeLogo: "",
  firstColor: "#68478D",
  secoundColor: "#FF0070",
  videoTutorial: "https://www.youtube.com/embed/K2Cdd3XB9vY",
  phone: "",
  email: "",
  country: "",
  countryCode: "",
  state: "",
  stateCode: "",
  population: "",
  address: "",
  codeZip: "",
  timezone: "",
  communication: 0,
  appIos: "https://apps.apple.com/es/app/fitmewise/id1531618177",
  appAndroid: "https://play.google.com/store/apps/details?id=com.fitmewise",
  isChat: 0,
  isChatExternal: 0,
  sets: null, // 1 -> centros_deportivos_1, 2 entrenadores_personales_1
  blockNutrition: 0,
  blockTraining: 0,
  complianceSchedule: 0,
  customerToGymSubscription: 0,
  multiCenterQuotas: 0,
  lessonModule: 0, //the same as usesLesson
  rulePenalty: 0,
  ruleMax: "100000",
  assistedModule: 0,
  slots: 0,
  catchmentModule: 0,
  recoveryModule: 0,
  ticketModule: 0,
  store: 0,
  courseModule: 0,
  accessModule: 0,
  accessModuleType: 1,
  typeBranch: "gimnasio",
  contract: null,
  availableMarketing: [],
  accountingModule: 0,
  taxAuthorities: 1,
  gtiCode: "",
  gtiUser: "",
  gtiPassword: "",
  gtiTerminal: null,
  paymentCardModule: 0,
  gateway: "stripe",
  publicKeyPayment:
    "pk_test_51IFiBGG0cWNM28zsOlvKkO4nVmBBFGRqM32hcGPbY8eWAU74lQoC88GJKfFkNL5GzD0yFUZyPNcBExUbstqhENug00vlR6yny4",
  privateKeyPayment:
    "sk_test_51IFiBGG0cWNM28zsXwV01MvhIFHJXwkqhvZEnFA17kmbtmBR9kHf4z8QJNictByt01hA8anIXfyavbKOIhOBmOlV00MdAKxyWG",
  prodIntegrity: null,
  directDebitModule: 0,
  usesSubscription: 0,
  availableSubscriptions: [],
  contractId: "",
  subscriptionBlocking: 0,
  trialPeriodEndDate: "2024-09-16",

  slug: "",
  status: 1,
  secretId: 0,
  vimeoUser: "",
  vimeoId: "",
  vimeoSecret: "",
  vimeoToken: "",
  web: "https://dash.fitmewise.com/download/filial-3-demogym",
  description: null,
  pathFile: "uploads/lessons/6574fd240d0dc.pdf",
  externalSource: "",
  setChatbot: null,
  createdAt: "2022-10-05T23:36:51.000000Z",
  updatedAt: "2024-09-03T05:06:56.000000Z",
  stripe: 0,
  nutrition: 0,
  videoClass: 0,
  appPusher: 0,
  lesson: 0,
  pdf: null,
  chatbotId: 80,
  stripeCustomerId: "cus_QjaMq9uO9Su6k4",
  usesBrand: 1,
  hourDifference: 0,
  contractSigning: 0,
  contractSigningImg: null,
  signatureDate: null,
  camerasModule: 0,
  logoColorModule: 1,
  videosModule: 0,
  postModule: 0,
  instagramModule: 0,
  accessPoint: null,

  setPost: 1,
  inAppStore: 0,
  storeModule: false,
  trafficLights: "[0,50,70,90]",
  additionalVideosModule: 1,
  cancellationAssisteds: 48,
  cancellationLessons: 48,
  cancellationSlots: 48,
  contractUrl: null,
  timeAccess: 20,
  iva: 10,
  commentTicket: "1test",
  taxId: "ecec",
  fitmewiseAccessImage: "uploads/fitmewise-access-images/1715821600.png",
  contractUser: null,
  clausesUser: null,
  daysAccess: 999,
  assistedAnticipationDays: 299,
  assistedTimeAccess: 8,
  courseAnticipationDays: null,
  courseTimeAccess: null,
  gym: {
    id: 16,
    gym: "DemoGym",
    benefits: null,
    logo: "rb1119nsgp.png",
    linkPrivacy: "https://www.google.com",
    linkTerms: "https://www.fitmewise.com",
    linkSite: "https://onelink.to/cnw4cm",
    themeColor: null,
    appIos: "https://apps.apple.com/es/app/fitmewise/id1531618177",
    appAndroid: "https://play.google.com/store/apps/details?id=com.fitmewise",
    status: 1,
    isDeleted: 0,
    createdAt: "2022-10-05T23:31:44.000000Z",
    updatedAt: "2024-02-02T03:36:48.000000Z",
    linkSubscription: null,
  },

  hasGymLink: false,
  hasTrainerLink: true,
};

export const branchValidationSchema = Yup.object({
  gym_id: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  branch: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  profile_avatar: Yup.mixed().nullable(),
  large_logo: Yup.mixed().nullable(),
  first_color: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  secound_color: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  video_tutorial: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  phone: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  email: Yup.string()
    .email(FIELD_REQUIRED_MESSAGE)
    .required(FIELD_REQUIRED_MESSAGE),
  country: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  population: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  address: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  code_zip: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  timezone: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  contrato: Yup.mixed().nullable(),

  // Nuevas validaciones anexadas
  state: Yup.string().optional().nullable(),
  app_ios: Yup.string().url(FIELD_REQUIRED_MESSAGE).optional(),
  app_android: Yup.string().url(FIELD_REQUIRED_MESSAGE).optional(),
  is_chat: Yup.boolean(),
  sets: Yup.mixed().nullable(),
  block_training: Yup.boolean(),
  block_nutrition: Yup.boolean(),
  compliance_schedule: Yup.boolean(),
  customer_to_gym_subscription: Yup.boolean(),
  multi_center_quotas: Yup.boolean(),
  uses_lesson: Yup.boolean(),
  cameras_module: Yup.boolean(),
  rule_penalty: Yup.mixed().nullable(),
  rule_max: Yup.mixed().nullable(),
  uses_assisteds: Yup.boolean(),
  slots: Yup.boolean(),
  catchment_module: Yup.boolean(),
  recovery_module: Yup.boolean(),
  ticket_module: Yup.boolean(),
  store: Yup.boolean(),
  course_module: Yup.boolean(),
  access_module: Yup.boolean(),
  access_module_type: Yup.string().optional(),
  type_branch: Yup.string().optional(),
  contract: Yup.mixed().nullable(),
  available_marketing: Yup.array()
    .of(
      Yup.object().shape({
        id: Yup.number().required(),
        name: Yup.string().required(),
      })
    )
    .nullable(),
  accounting_module: Yup.boolean(),
  direct_debit_module: Yup.boolean(),
  tax_authorities: Yup.string().nullable(),

  gti_code: Yup.string()
    .nullable()
    .when("tax_authorities", {
      is: "GTI",
      then: (schema) => schema.required(FIELD_REQUIRED_MESSAGE),
      otherwise: (schema) => schema.optional(),
    }),

  gti_user: Yup.string()
    .nullable()
    .when("tax_authorities", {
      is: (value) => value === "GTI" || value === "SIIGO",
      then: (schema) => schema.required(FIELD_REQUIRED_MESSAGE),
      otherwise: (schema) => schema.optional(),
    }),

  gti_password: Yup.string()
    .nullable()
    .when("tax_authorities", {
      is: (value) => value === "GTI" || value === "SIIGO",
      then: (schema) => schema.required(FIELD_REQUIRED_MESSAGE),
      otherwise: (schema) => schema.optional(),
    }),

  gti_terminal: Yup.string()
    .nullable()
    .when("tax_authorities", {
      is: "GTI",
      then: (schema) => schema.required(FIELD_REQUIRED_MESSAGE),
      otherwise: (schema) => schema.optional(),
    }),
  payment_card: Yup.boolean(),
  gateway: Yup.string().optional().nullable(),
  public_key_payment: Yup.string()
    .nullable()
    .when("gateway", {
      is: (value) => value === "Stripe" || value === "Wompi",
      then: (schema) => schema.required(FIELD_REQUIRED_MESSAGE),
      otherwise: (schema) => schema.optional(),
    }),
  private_key_payment: Yup.string()
    .nullable()
    .when("gateway", {
      is: (value) => value === "Stripe" || value === "Wompi",
      then: (schema) => schema.required(FIELD_REQUIRED_MESSAGE),
      otherwise: (schema) => schema.optional(),
    }),
  prod_integrity: Yup.string()
    .nullable()
    .when("gateway", {
      is: "Wompi",
      then: (schema) => schema.required(FIELD_REQUIRED_MESSAGE),
      otherwise: (schema) => schema.optional(),
    }),
  uses_subscription: Yup.boolean(),
  available_subscriptions: Yup.array()
    .of(Yup.object({ id: Yup.string(), name: Yup.string() }))
    .nullable(),
  contract_id: Yup.number().optional().nullable(),
  subscription_blocking: Yup.boolean(),
  trial_period_days: Yup.string().optional(),
});

export type BranchValues = typeof branchInitialValues;
